export const AUTH_TRY = "AUTH_TRY";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_CLEAN_UP = "AUTH_CLEAN_UP";
